import React, { useEffect } from "react";
import Image from "next/image";
import { bem, UrlButton, Beacon, ScrollLink } from "@obby/components";
import { styles } from "./TopClassesPage.style";

const cn = bem("blog-page");
export function TopClassesPageView({
  topClasses: {
    title,
    image,
    excerpt,
    intro,
    postIntro,
    conclusion,
    blogLinks,
    classes
  }
}) {
  useEffect(() => {
    // Segment
    let dataTrack = {
      name: "Best Classes",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.rudderanalytics)
      window.rudderanalytics.page(dataTrack.name, dataTrack);
  }, []);
  const onMenuItemClick = (menuItem, event) => {
    if (menuItem.isRealLink) {
      window.location = menuItem.link;
    }
  };
  const onClickProxy = courseItem => {
    return event => {
      if (onMenuItemClick) {
        onMenuItemClick(courseItem, event);
      }
    };
  };

  return (
    <div className={`${cn()} ${styles.blogPage()}`}>
      <header className={`${cn("header")}`}>
        <div className="container-fluid">
          <div className={`blog-page-header ${styles.blogPageHeader()}`}>
            <section
              className={`${cn("header-title")} ${styles.headerTitle()}`}
            >
              <h1>{title}</h1>
              <p>{excerpt}</p>
            </section>
            <section
              className={`${cn("header-author")} ${styles.headerAuthor()}`}
            >
              <div
                className={`${cn(
                  "header-author-img"
                )} ${styles.headerAuthorImg()}`}
              >
                <img
                  src="https://obby.co.uk/blog/content/images/size/w100/2021/09/Chloe.png"
                  alt="Clhoe Williams"
                />
              </div>
              <div
                className={`${cn(
                  "header-author-content"
                )} ${styles.headerAuthorContent()}`}
              >
                <p>CHLOE WILLIAMS</p>
                <p>14 JAN 2021 . 8 MIN READ</p>
              </div>
            </section>
          </div>
        </div>
      </header>
      <main className={`${cn("main")}`}>
        <div
          className={`${cn("main-header-img")} ${styles.mainHeaderImg({
            css: { paddingTop: "$24", "@sm": { display: "none" } }
          })}`}
        >
          <Image src={image.href} alt={image.desc} height="383" width="575" />
        </div>
        <div className="container-fluid">
          <div className={`${cn("main-header")} ${styles.mainHeader()}`}>
            <div
              className={`${cn("main-header-img")} ${styles.mainHeaderImg({
                css: {
                  display: "none",
                  "@sm": { display: "block" }
                }
              })}`}
            >
              <Image
                src={image.href}
                alt={image.desc}
                height="693px"
                width="1040px"
              />
            </div>
            <div
              className={`${cn(
                "main-header-content"
              )} ${styles.mainHeaderContent()}`}
            >
              <p>{intro}</p>
              {/* Component with list of items   */}
              <div className={`list-classes `}>
                <p className={`list-classes__title ${styles.classesTitle()}`}>
                  {postIntro}
                </p>

                <ul className={`list-classes__items ${styles.classesItems()}`}>
                  {classes.map((course, index) => (
                    <li
                      key={`${index}-list-item`}
                      className={`list-classes__item ${styles.classesItem()}`}
                    >
                      <ScrollLink
                        key={index}
                        href={`#${course.title}`}
                        className="list-classes__link"
                        onClick={onClickProxy(course)}
                        offset={course.offset}
                      >
                        {course.title}
                      </ScrollLink>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {classes.map((course, index) => (
            <section
              key={`${index}-course-section`}
              className={`${cn("section")} ${styles.section()}`}
            >
              <Beacon id={course.title} />
              <div className={`${cn("section-title")}`}>
                <p className={`${styles.sectionTitle()}`}>{course.title}</p>
              </div>
              <div
                className={`${cn(
                  "section-img"
                )} ${styles.sectionImg()} ${styles.sectionImg()}`}
              >
                <Image
                  src={course.image.href}
                  alt={course.image.desc}
                  height="580px"
                  width="860px"
                />
              </div>
              <div className={`${cn("section-content")}`}>
                {course.content.map((text, index) => (
                  <p key={`${index}-section-content`}>{text}</p>
                ))}
              </div>
              <div
                className={`${cn("section-button")} ${styles.sectionButton()}`}
              >
                <UrlButton
                  color="robbinsEggBlue"
                  text="BOOK NOW ON OBBY"
                  width="auto"
                  textMode="uppercase"
                  href={course.link.href}
                  size="large"
                />
              </div>
            </section>
          ))}
          <section className={`${cn("advice")} ${styles.advice()}`}>
            <p className={`${styles.sectionTitle()}`}>Need more advice?</p>
            <div className={`${cn("advice-content")}`}>
              <p>{conclusion}</p>
            </div>
          </section>

          <section className={`${cn("blog-links")} ${styles.blogLinks()}`}>
            <div className={`${cn("blog-links-content")}`}>
              <p>
                Take a read of some of our other amazing guides and best round
                ups below. We're sure you'll find something useful, oh - and
                don't forget to share the love.
              </p>
              <ul className="list-blog__items">
                {blogLinks.map((link, index) => (
                  <li
                    key={`${index}-blog-item`}
                    className={`list-blog__item ${styles.classesItem()}`}
                  >
                    <a href={link.href}>{link.desc}</a>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
